import { createSelector } from '@ngrx/store';
import { IAppState } from 'app/IAppState';

const pendingChanges = (state: IAppState) => state.userGroups.pendingChanges;

export const selectHasChanges = createSelector(
    pendingChanges,
    (state: IPendingChangesState) => state.hasChanges
);

export const selectOriginalUserGroup = createSelector(
    pendingChanges,
    (state: IPendingChangesState) => state.originalUserGroup
);

export const selectRequestValidation = createSelector(
    pendingChanges,
    (state: IPendingChangesState) => state.requestValidation
);

export const selectNextGuid = createSelector(
    pendingChanges,
    (state: IPendingChangesState) => state.nextGuid
);

export const selectPendingChangeAction = createSelector(
    pendingChanges,
    (state: IPendingChangesState) => state.action
);
